import { render, staticRenderFns } from "./ListaDispensas.vue?vue&type=template&id=6d4c6188&scoped=true&"
import script from "./ListaDispensas.vue?vue&type=script&lang=js&"
export * from "./ListaDispensas.vue?vue&type=script&lang=js&"
import style0 from "./ListaDispensas.vue?vue&type=style&index=0&id=6d4c6188&lang=scss&scoped=true&"
import style1 from "./ListaDispensas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c6188",
  null
  
)

export default component.exports